import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { cancelStatement, depositStatements, fetchStatements } from './statementsApi';

const statementsKey = ['statements'] as const;

export function useStatements() {
  return useQuery({ queryKey: statementsKey, queryFn: fetchStatements });
}

/** Un dépôt ou une annulation crée ou retire des écritures : tout ce qui les lit est à rafraîchir. */
function useInvalidateLedger() {
  const queryClient = useQueryClient();
  return () => {
    for (const key of ['statements', 'assignment-queue', 'assignment-rules', 'transactions', 'annual-summary', 'forecast']) {
      void queryClient.invalidateQueries({ queryKey: [key] });
    }
  };
}

export function useDepositStatements() {
  const invalidate = useInvalidateLedger();
  return useMutation({ mutationFn: (files: readonly File[]) => depositStatements(files), onSuccess: invalidate });
}

export function useCancelStatement() {
  const invalidate = useInvalidateLedger();
  return useMutation({ mutationFn: (id: number) => cancelStatement(id), onSuccess: invalidate });
}
